/* tslint:disable */
/* eslint-disable */
export enum CustomerOperation {
  ACTIVATE_CUSTOMER = 'ACTIVATE_CUSTOMER',
  DEACTIVATE_CUSTOMER = 'DEACTIVATE_CUSTOMER'
}
